// extracted by mini-css-extract-plugin
export default {"specialtySelect":"SearchBarSpecialtySelect_specialtySelect__He8cM","specialtySelectContainer":"SearchBarSpecialtySelect_specialtySelectContainer__ztR7C"};